import FullWidthHeader from "@components/BasicComponents/FullWidthHeader/FullWidthHeader"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import {getPosts} from "@config/modules"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import CustomerStories from "@jsons/customerStories.json"
import ExpertiseJson from "@jsons/expertise.json"
import ExpertiseCallToAction from "@pages/Expertise/ExpertiseCallToAction/ExpertiseCallToAction"
import ExpertiseCustomerCards from "@pages/Expertise/ExpertiseCustomerCards/ExpertiseCustomerCards"
import ExpertiseIntro from "@pages/Expertise/ExpertiseIntro/ExpertiseIntro"
import ExpertiseSecurity from "@pages/Expertise/ExpertiseSecurity/ExpertiseSecurity"
import ExpertiseStudio from "@pages/Expertise/ExpertiseStudio/ExpertiseStudio"
import UseCasesSlider from "@pages/Expertise/ExpertiseUseCasesSlider/UseCasesSlider"
import ExpertiseWorkshop from "@pages/Expertise/ExpertiseWorkshop/ExpertiseWorkshop"
import React from "react"

type Props = {}

const expertise = (props: Props): JSX.Element => {
	const pageData = getTranslatedPageData(ExpertiseJson, true, true)
	const ExpertiseSections = getValueOrThrow(pageData.AdvancedSideAsset)

	const stories = getPosts("CustomerStoriesModule", {data: CustomerStories})

	return (
		<>
			<HeadMeta meta={pageData.metaData} />

			<FullWidthHeader
				data={getValueOrThrow(ExpertiseSections?.[0].mainContent)[0]}
				position={"left"}
				size={"XL"}
				withOverlay
			/>
			<ExpertiseIntro data={ExpertiseSections[1]} />

			<ExpertiseCustomerCards
				data={ExpertiseSections[2]}
				stories={stories}
			/>

			<ExpertiseSecurity data={ExpertiseSections[3]} />

			<ExpertiseStudio data={ExpertiseSections[4]} />

			<UseCasesSlider data={ExpertiseSections[8]} />

			<ExpertiseWorkshop
				data={[ExpertiseSections[5], ExpertiseSections[6]]}
			/>

			<ExpertiseCallToAction data={ExpertiseSections[7]} />
		</>
	)
}

export default expertise
